var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { bind } from "decko";
import { DialogHeader } from "./dialogheader";
import { Portal } from "./portal";
import { css, cx, keyframes } from "emotion";
import { getThemeColorVar } from "../helper/color";
function dialogHasHeader(props) {
    return props.title !== undefined;
}
const animation = keyframes `
  0% {
    opacity: 0;
  }

  100% {
    opacity: 100;
  }
`;
const dialogClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    borderRadius: "3px",
    minWidth: "30%",
    maxWidth: "85%",
    boxShadow: `0 3px 15px ${getThemeColorVar("background", "dark")}`,
    zIndex: 9999999,
    display: "flex",
    flex: "0 1 auto",
    flexDirection: "column",
    animation: `${animation} .5s`,
});
export class Dialog extends React.Component {
    handleCloseButton(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onClose && this.props.onClose();
    }
    handleClickOutside(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.closeOnClickOutside)
            this.props.onClose && this.props.onClose();
    }
    render() {
        const { id } = this.props;
        const window = (React.createElement("div", { id: id, className: cx(dialogClass), style: { width: this.props.width, height: this.props.height } },
            dialogHasHeader(this.props) && (React.createElement(DialogHeader, { modifier: this.props.modifier, icon: this.props.icon, title: this.props.title, closeButton: this.props.closeButton, onClose: this.handleCloseButton })),
            this.props.children));
        if (this.props.withoutPortal) {
            return window;
        }
        else {
            return React.createElement(Portal, { onClickOutside: this.handleClickOutside }, window);
        }
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Dialog.prototype, "handleCloseButton", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Dialog.prototype, "handleClickOutside", null);
export default Dialog;
//# sourceMappingURL=dialog.js.map